/**
 * NARA Tourism — Card Styles con identidad "Oceánica"
 * Borde lateral de color + fondo degradado sutil + ola decorativa
 */

// Card base oceánica — borde izquierdo turquesa + fondo degradado sutil
export const cardStyle = {
  borderRadius: '0 16px 16px 0',
  background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,253,250,0.85) 100%)',
  backdropFilter: 'blur(20px)',
  boxShadow: '0 4px 24px rgba(8, 145, 178, 0.06), inset 0 1px 0 rgba(255,255,255,0.9)',
  borderLeft: '4px solid #0891b2',
  borderTop: '1px solid rgba(8, 145, 178, 0.08)',
  borderRight: '1px solid rgba(8, 145, 178, 0.08)',
  borderBottom: '1px solid rgba(8, 145, 178, 0.08)',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 12px 32px rgba(8, 145, 178, 0.12), 0 4px 12px rgba(8, 145, 178, 0.08)',
    borderLeftColor: '#06b6d4',
  },
  // Ola decorativa SVG en esquina superior derecha
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    width: 80,
    height: 40,
    background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 40'%3E%3Cpath d='M80 0 C65 0 60 12 45 12 C30 12 28 0 15 0 C8 0 3 4 0 8 L0 0 Z' fill='%230891b2' opacity='0.04'/%3E%3Cpath d='M80 0 C70 0 65 8 55 8 C45 8 40 0 30 0 C20 0 15 6 0 6 L0 0 Z' fill='%2306b6d4' opacity='0.03'/%3E%3C/svg%3E") no-repeat`,
    backgroundSize: 'cover',
    pointerEvents: 'none',
  },
};

// Variante con borde de color personalizado (para estados, categorías)
export const cardStyleColored = (borderColor) => ({
  ...cardStyle,
  borderLeft: `4px solid ${borderColor}`,
  '&:hover': {
    ...cardStyle['&:hover'],
    borderLeftColor: borderColor,
  },
  '&::after': cardStyle['&::after'],
});

// Card para KPIs — más compacta, con barra superior de gradiente
export const kpiCardStyle = (gradient, shadowColor) => ({
  ...cardStyle,
  borderLeft: 'none',
  borderRadius: 4,
  p: 2,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0, left: 0, right: 0,
    height: 3,
    background: gradient,
    borderRadius: '16px 16px 0 0',
  },
  '&::after': cardStyle['&::after'],
  '&:hover': {
    transform: 'none',
    boxShadow: `0 8px 24px ${shadowColor || 'rgba(8,145,178,0.1)'}`,
  },
});

// Icon box con gradiente — para headers de sección
export const iconBoxStyle = (gradient, shadow) => ({
  width: 44, height: 44, borderRadius: 3,
  background: gradient,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  color: '#fff', boxShadow: `0 8px 20px ${shadow}`, flexShrink: 0,
  '& svg': { fontSize: 22 }
});
